import React,
{
    useState,
    useEffect,
    useRef,
} from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    Grid,
    Modal,
    IconButton,
    Typography,
    Portal,
    LinearProgress,
} from '@material-ui/core';
import {Virtuoso} from 'react-virtuoso';
import {TransitionProps} from "@material-ui/core/transitions";
import {makeStyles} from "@material-ui/styles";
import Firebase from 'firebase/app';
import FullNotificationDialog from "./FullNotificationDialog";
import {
    Visibility,
    VisibilityOff,
    Delete,
    DeleteOutline,
} from "@material-ui/icons";
import {FeedListItem} from "../Feed/FeedListItem";
import NotificationElement from "./NotificationElement";
import {useAuthState} from "react-firebase-hooks/auth";
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const NotificationPage = (props: any) => {
    const {open, dismiss, onMessagesLoad} = props
    const [messageResponse, setMessageResponse] = useState<any>();
    const [showTrash, toggleShowTrash] = useState<boolean>(false);
    const [user, authLoading, authError] = useAuthState(Firebase.auth());
    const [selectedNotification, selectNotification] = useState<string>();
    const contentRef = useRef(null);
    const [containerRef, setContainerRef] = useState();
    const pathRef = useRef('?limit=15&offset=0&mode=');
    const modeRef = useRef('all')

    const onClose = () => {
        selectNotification(undefined);

    }

    const getMessages = async () => {
        // console.log(modeRef.current)
        // console.log(messageResponse)
        const url = `https://idverify.manhattan.edu/apiv2/api/messagebox/inbox${pathRef.current}`;
        let firebase_token = await Firebase.auth().currentUser.getIdToken();
        try {
            let messagesResp = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${firebase_token}`
                }
            });
            let messagesJson = await messagesResp.json()
            let messageMap = new Map(messageResponse?.messages ?? []);
            let messageCount = messageResponse?.messageCount ?? 0;
            // console.log(messageResponse?.liveMessages)
            let liveMessages: string[] = messageResponse?.liveMessages ?? [];

            // console.log(messagesJson)
            let message;
            for (let index in messagesJson.messages) {
                    message = messagesJson.messages[index];
                    if (showTrash ? message.DELETED === 'Y' : message.DELETED !== 'Y')
                        liveMessages.push(message.SURROGATE_ID);

                    messageMap.set(message.SURROGATE_ID, message);

            }
            // console.log(liveMessages, 'messageCount')

            onMessagesLoad({unread: messagesJson.unread.all})

            setMessageResponse({...messagesJson, messages: messageMap, messageCount: liveMessages.length, liveMessages})

        } catch(error) {
            // console.log(error)


            onMessagesLoad({error})
        }
    }

    const updateReadStatus = (index: string, status: 'Y' | 'N') => {
        // console.log('lets go')
       let messages = messageResponse.messages;
        let message = messages.get(index);
        let updatedMessage = {...message, READ: status};
        messages.set(index, updatedMessage)
        // console.log(messages)

        setMessageResponse({...messageResponse, unread: {...messageResponse.unread, all: messageResponse.unread.all + (status === 'Y' ? -1 : 1)}, messages})
    }

    const updateDeletionStatus = (index: string, status: 'Y' | 'N') => {
        let messages = messageResponse.messages;

        messages.delete(index);

        // let updatedMessage = {...message, DELETED: status};
        // messages.set(index, updatedMessage)
        // let messageCount = messageResponse.messageCount + (status === 'Y' ? -1 : 1);
        let liveMessages =[...messages.keys()];

        // console.log('deleted', index)
        setMessageResponse({...messageResponse, messages, messageCount: liveMessages.length, liveMessages})
    }

    useEffect(() => {
        if (messageResponse)
            onMessagesLoad({unread: messageResponse.unread.all})

        if (user && messageResponse === undefined)
            getMessages();


    }, [messageResponse])

    useEffect(() => {
        if (open || user) getMessages()
    }, [open, user])

    useEffect( () => {
        if (user && selectedNotification === undefined) {
            // console.log('updated')
            // getMessages()
        }
    }, [selectedNotification])

    useEffect(() => {
        if (user) {
            setMessageResponse(undefined);
            // console.log(messageResponse)
        }

    }, [showTrash])
    const onSelect = (index: string) => {
        selectNotification(index)
    }

    const getItems = (index: any) => {
        const id = messageResponse.liveMessages[index];
        if (messageResponse.messages.get(id) ) {

            const notification: any = messageResponse.messages.get(id);

            return (

                <div className={classes.itemContainer}>
                        <NotificationElement
                            notification={notification}
                            onSelect={() => onSelect(notification.SURROGATE_ID)}
                        />
                </div>
            )
        } else {
            return (<></>)
        }
    };
    const loadMore = (index: number) => {
        if (index < messageResponse.count.all) {
            // console.log(messageResponse.meta.next)
            pathRef.current = messageResponse.meta.next;
            getMessages()
        }
    }
    //
    // const updateLiveMessages = (showTrash: boolean) => {
    //     let messages = messageResponse.messages;
    //     let message;
    //     let liveMessages = [...messages.keys()].filter((key: string) => {
    //         message = messages.get(key);
    //         return showTrash ? message.DELETED === 'Y' : message.DELETED !== 'Y';
    //     });
    //
    //     setMessageResponse({...messageResponse, messageCount: liveMessages.length, liveMessages})
    // }


    const classes = useStyle();
    return (
        <Modal
            open={open}
            onClose={() => {
                if (showTrash) {
                    modeRef.current = 'all';
                    pathRef.current = '?limit=15&offset=0&mode=all';
                    toggleShowTrash(false);
                }
                dismiss()
            }}
            closeAfterTransition
        >
            <Slide direction={'up'} in={open} mountOnEnter unmountOnExit>
                <Grid container className={classes.mainContainer}>
                    <Header unreadNotificationCount={messageResponse?.unread.all || 0} showTrash={showTrash}/>
                    {messageResponse === undefined &&
                        <Grid item

                        >
                            <LinearProgress

                                classes={{
                                    colorPrimary: classes.loadingBarBase,
                                    barColorPrimary: classes.loadingBar,
                                }}/>
                        </Grid>
                    }
                    {messageResponse &&
                        <Virtuoso
                            overscan={500}
                            style={{ flex: 1, marginLeft: 16, marginRight: 16, overflowY: 'initial', overflow: 'scroll', marginBottom: 64}}
                            totalCount={messageResponse.messageCount}
                            item={getItems}
                            endReached={loadMore}
                        />}

                    <Footer
                        showTrash={showTrash}
                        dismiss={() => {
                        if (showTrash) {
                            modeRef.current = 'all';
                            pathRef.current = '?limit=15&offset=0&mode=all';
                            toggleShowTrash(false);
                        }
                        dismiss()
                    }}
                    onClickTrash={() => {
                        if (window.webkit && window.webkit.messageHandlers.selection) {
                            window.webkit.messageHandlers.selectionPrepare.postMessage({body: true})
                            window.webkit.messageHandlers.selection.postMessage({body: true})
                        }
                        modeRef.current = modeRef.current === 'all' ? 'deleted' : 'all';
                        pathRef.current = modeRef.current === 'all' ? '?limit=15&offset=0&mode=all' : '?limit=15&offset=0&mode=deleted'
                        toggleShowTrash(!showTrash)
                    }}/>
                    {messageResponse &&
                        <FullNotificationDialog
                            open={selectedNotification !== undefined}
                            onClose={onClose}
                            notificationID={selectedNotification}
                            index={selectedNotification}
                            updateReadStatus={updateReadStatus}
                            updateDeletionStatus={updateDeletionStatus}
                        />
                    }
                </Grid>

            </Slide>
        </Modal>
    );
}

const Header = (props: any) => {
    const {unreadNotificationCount, showTrash} = props;
    const classes = useStyle({showTrash});
    return (
        <Grid item className={classes.header} xs={12}>
            <Grid container className={classes.headerContentContainer} alignItems={'center'}>
                <Grid item>
                    <Typography className={classes.title} variant={'h5'}>{showTrash ? 'Trash' : 'Notifications'}</Typography>
                </Grid>
                {!showTrash && <Grid item >
                    {unreadNotificationCount > 0 &&
                        <Typography className={classes.unreadStatus}>
                            {`(${unreadNotificationCount} unread)`}
                        </Typography>
                    }
                </Grid>}
            </Grid>
        </Grid>
    )
}

const Footer = (props: any) => {
    const {dismiss, onClickTrash, showTrash} = props;
    const classes = useStyle();
    return (
        <Grid className={classes.footer} item xs={12}>
            <Grid
                container
                direction={'row'}
                justify={'space-between'}
            >
                <Grid item>
                    <Button
                        variant={'outlined'}
                        color={'secondary'}
                        onClick={dismiss}
                    >
                        Close
                    </Button>
                </Grid>
                <Grid item>
                    <IconButton onClick={onClickTrash}>
                        {showTrash ? <Delete /> : <DeleteOutline />}
                    </IconButton>
                </Grid>
            </Grid>
        </Grid>
    )
}

const useStyle = makeStyles({
    actions: {},
    mainContainer:{
        flexDirection: 'column',
        height: '100%',
        background: 'white'
    },
    itemContainer: {
        paddingTop: 8,
        paddingBottom: 8,
    },
    content: {
        padding: 0,
        height: 'calc(100% - 64px)'

    },
    title: {
      color: 'white',
    },
    footer: {
        minHeight: 54,
        height: 54,
        width: '100%',
        background: 'white',
        flexBasis: 'auto',
        padding: 8,
        position: 'absolute',
        bottom: 0,

    },
    header: {
        minHeight: 64,
        height: 64,
        width: '100%',
        background: (props) => props.showTrash ? '#71716E' : '#046A38',
        flexBasis: 'auto',
        paddingLeft: 24,
        paddingRight: 24,
    },
    dialogTitle: {
        backgroundColor: '#046A38',
        color: 'white',
    },
    unreadStatus: {
        marginLeft: 8,
        color: 'white',
    },
    headerContentContainer: {
        height: '100%'
    } ,
    loadingBarBase: {
        backgroundColor: 'rgba(163, 208, 50, 35%)'
    },
    loadingBar: {
        backgroundColor: 'rgba(163, 208, 50, 100%)'
    }
})

export default NotificationPage;